import utils from './utils';
import wsUtils from './wsUtils';
import content from './content';

let closeHandlerEvent;
let iFrameState = 0;
// 添加防重复标志
let isInitializing = false;
let hasInitialized = false;

const getInitUserStorageKey = (channelId, field) => {
    return 'zhini_init_user_' + field + '_' + channelId;
}

const isValidAvatarUrl = (value) => {
    if (typeof value !== 'string') {
        return false;
    }
    const url = value.trim();
    if (!/^https?:\/\//i.test(url)) {
        return false;
    }
    try {
        const parsedUrl = new URL(url);
        const pathname = parsedUrl.pathname || '';
        return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(pathname);
    } catch (e) {
        return false;
    }
}

const saveInitUserValue = (channelId, field, value) => {
    if (!channelId || value === undefined) {
        return;
    }
    const stringValue = value === null ? '' : String(value);
    if (field === 'avatar' && !isValidAvatarUrl(stringValue)) {
        return;
    }
    if (field === 'name') {
        window._ZHINI_INIT_USER_NAME = stringValue;
    } else if (field === 'avatar') {
        window._ZHINI_INIT_USER_AVATAR = stringValue;
    }
    try {
        localStorage.setItem(getInitUserStorageKey(channelId, field), stringValue);
    } catch (e) {}
}

const saveInitUserInfo = (data) => {
    if (!data) {
        return;
    }
    const channelId = data.channel_id || localStorage.getItem('zhini_channel_id') || '';
    if (data.name !== undefined) {
        saveInitUserValue(channelId, 'name', data.name);
    } else if (data.nickname !== undefined) {
        saveInitUserValue(channelId, 'name', data.nickname);
    }
    if (data.avatar !== undefined) {
        saveInitUserValue(channelId, 'avatar', data.avatar);
    }
}

const setiFrameState = (state) => {
    iFrameState = state;
}

const handleSpreadActions = () =>{
    // 延迟500ms后执行，等待 open_chat 接口响应
        wsUtils.startProcess("setConsultingActive", {active: true, reason: 'spread'});
        utils.scrollDownEnd(undefined, 0);
        setiFrameState(1);
        if (window.handleZhiniPanelOpen && typeof window.handleZhiniPanelOpen === 'function') {
            window.handleZhiniPanelOpen();
        }
        wsUtils.startProcess("sendMsgH", {message: {msgtype: 'open_chat'}});
}

const init = () => {
    window.addEventListener('message', function(event) {
        closeHandlerEvent = event;
        var data = event.data;
            
        switch (data.type) {
            case 'init': {
                // 收到 init 消息，保存配置信息
                    
                // 【重要】不再保存 token，因为 InnerWeb 会自己调用 newlogin 验证
                // SDK 层不再传递 token
                    
                // 【关键】保存 SDK 传递的 client_id 到全局变量，供 newlogin 使用
                if (data.client_id) {
                    window._ZHINI_INIT_CLIENT_ID = data.client_id;
                }

                saveInitUserInfo(data);
                    
                // 【重要】保存 config_data 到内存变量（不使用 localStorage）
                if (data.config_data) {
                    window._ZHINI_CONFIG_DATA = data.config_data;
                    
                    // 【关键】配置保存完成后，立即同步触发样式注入
                    if (window.triggerInitStyles && typeof window.triggerInitStyles === 'function') {
                        // 使用 setTimeout 0，确保在当前事件循环结束后立即执行
                        setTimeout(function() {
                            window.triggerInitStyles();
                        }, 0);
                    }
                }
                    
                // 保存 isLocalDev 标志
                if (data.isLocalDev !== undefined) {
                    localStorage.setItem('zhini_is_local_dev', data.isLocalDev ? 'true' : 'false');
                }
                
                // 【重要】保存 isHide 标志（决定是否调用 newlogin）
                if (data.isHide !== undefined) {
                    localStorage.setItem('zhini_is_hide_' + data.channel_id, data.isHide ? 'true' : 'false');
                }
                    
                break;
            }
            case 'ping': {
                closeHandlerEvent.source.postMessage({type: 'pong'}, closeHandlerEvent.origin);
                break;
            }
            case 'largeImg': {
                // 转发给父窗口（SDK iframe）
                if (window.parent && window.parent !== window) {
                    window.parent.postMessage(data, '*');
                }
                break;
            }
            case 'previewVideo': {
                // 转发给父窗口（SDK iframe）
                if (window.parent && window.parent !== window) {
                    window.parent.postMessage(data, '*');
                }
                break;
            }
            case 'panelState': {
                if (data.state === 'open') {
                    wsUtils.startProcess("setConsultingActive", {active: true, reason: 'panel_open'});
                    setiFrameState(1);
                    if (window.handleZhiniPanelOpen && typeof window.handleZhiniPanelOpen === 'function') {
                        window.handleZhiniPanelOpen();
                    }
                } else if (data.state === 'close') {
                    wsUtils.startProcess("setConsultingActive", {active: false, reason: 'panel_close'});
                    setiFrameState(0);
                    if (window.handleZhiniPanelClose && typeof window.handleZhiniPanelClose === 'function') {
                        window.handleZhiniPanelClose();
                    }
                }
                break;
            }
            case 'tab_visible': {
                if (window.handleZhiniTabVisible && typeof window.handleZhiniTabVisible === 'function') {
                    window.handleZhiniTabVisible();
                }
                break;
            }
            case 'spread': {
            
                // 防重复检查
                if (isInitializing) {
                    return;
                }
            
                if (!window.requestHis) {
                    // 【重要】检查 isHide 标志，决定是否调用 newlogin
                    var channelId = localStorage.getItem('zhini_channel_id') || '';
                    var isHide = localStorage.getItem('zhini_is_hide_' + channelId) === 'true';
                    
                    if (!hasInitialized) {
            
                        // 设置初始化标志，防止重复调用
                        isInitializing = true;
                        hasInitialized = true;
            
                        // 【关键】如果 isHide 为 true，不调用 newlogin（半初始化状态）
                        if (!isHide) {
                            // InnerWeb 会自己调用 newlogin
                            content.startProcess();
                
                            // 延迟调用 requestMessageList，等待 startProcess 完成
                            setTimeout(() => {
                                if (window.requestMessageList) {
                                    window.requestMessageList("", (res) => {
                                        if (res == 1) {
                                            handleSpreadActions();
                                        }
                                        // 重置初始化标志
                                        isInitializing = false;
                                    });
                                } else {
                                    handleSpreadActions();
                                    // 重置初始化标志
                                    isInitializing = false;
                                }
                            }, 1000); // 等待 1 秒让 startProcess 完成
                        } else {
                            // isHide 为 true，不调用 newlogin，直接重置标志
                            // 等待用户调用 showBtn 或 showPanel 时再初始化
                            isInitializing = false;
                        }
            
                    } else {
                        // 已初始化，直接处理 spread
                        handleSpreadActions();
                    }
                } else {
                    handleSpreadActions();
                }
                break;
            }
        }
        bindHideChatButton();
    }, false);

    // 延迟绑定 onclick 事件处理函数
    function bindHideChatButton() {
        const btnHideChat = document.getElementById('btn-hide-chat');
        if (btnHideChat && closeHandlerEvent) {
            btnHideChat.onclick = function () {
                closeHandlerEvent.source.postMessage({type: 'hidePanel'}, closeHandlerEvent.origin);
                wsUtils.startProcess("setConsultingActive", {active: false, reason: 'hide_button'});
                setiFrameState(0);
                if (window.handleZhiniPanelClose && typeof window.handleZhiniPanelClose === 'function') {
                    window.handleZhiniPanelClose();
                }
            };
        } else {
            setTimeout(bindHideChatButton, 100); // 每100毫秒检查一次
        }
    }
};

const postMessage = (message, retryCount = 0) => {
    if (!closeHandlerEvent) {
        // 降级方案：直接使用 window.parent
        try {
            window.parent.postMessage(message, '*');
        } catch (error) {
            // 忽略错误
        }
        
        // 如果重试次数大于 0，继续重试
        if (retryCount-- > 0) {
            setTimeout(() => {
                postMessage(message, retryCount);
            }, 100);
        }
        return;
    }
    
    closeHandlerEvent.source.postMessage(message, closeHandlerEvent.origin);
}

export default{
    getifameState: () => iFrameState,
    setiFrameState,
    init,
    postMessage,
}



// WEBPACK FOOTER //
// ./src/js/shelltool.js